import "./TermsAndConditions.scss";
import { Link } from "react-router-dom";
import ArrowIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
const TermsAndConditions = () => {
  return (
    <div className="terms-and-conditions">
      <div className="container">
        <h4 className="title">اعدادت الشروط والاحكام</h4>
        <div className="actions-container">
          <Link className="action-link" to={"/terms-and-conditions/students"}>
            الشروط والاحكام ( الطالب )
            <ArrowIcon className="icon" />
          </Link>
          <Link className="action-link" to={"/terms-and-conditions/trainers"}>
            الشروط والاحكام ( المدرب )
            <ArrowIcon className="icon" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
